import {
    SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_DELAY_HOURS,
    SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_ENABLED,
    SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_PROMOCODE_ID,
    SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_THROTTLE_DAYS,
} from '../../constants';
import { useSettingsFactory } from './useSettingsFactory';

export const useSettingsAbandonedCartEmail = () =>
    useSettingsFactory({
        abandonedCartEmailEnabled: { path: SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_ENABLED },
        abandonedCartEmailDelayHours: { path: SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_DELAY_HOURS },
        abandonedCartEmailPromocodeId: { path: SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_PROMOCODE_ID },
        abandonedCartEmailThrottleDays: { path: SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_THROTTLE_DAYS },
    });
